// lottie
import { Player as LottiePlayer } from '@lottiefiles/react-lottie-player';

// assets
// @transform-path ../../../../../../src/assets/animation/success.json
import successAnimation from '@/assets/animation/success.json';

/**
 * LottieAnimation displays a Lottie animation.
 */
export const LottieAnimation: React.FC<LottieAnimationProps> = ({
  src = successAnimation,
  loop = true,
  autoplay = true,
}: LottieAnimationProps) => {
  return <LottiePlayer autoplay={autoplay} loop={loop} src={src} />;
};

interface LottieAnimationProps {
  src: any;
  loop: boolean;
  autoplay: boolean;
}

LottieAnimation.displayName = 'LottieAnimation';

export default LottieAnimation;
